import React, { PureComponent } from "react";
import "./Forms.css";
// add .error to component for error state.

class TextArea extends PureComponent {
  static defaultProps = {
    rows: "4",
    cols: "120",
    classes: "",
    autoComplete: "on",
  };
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`form-wrapper ${this.props.classes}`}>
        <textarea
          maxLength={this.props.maxLength}
          autoComplete={this.props.autoComplete}
          {...this.props}
          {...{iserror : undefined, labelerror: undefined}}
        ></textarea>
        {this.props.iserror && (
          <div className="errorText">{this.props.labelerror}</div>
        )}
      </div>
    );
  }
}
export default TextArea;
